






































































type Prop<T> = () => T
import Vue from 'vue'
import FormValues from '@/types/form-values'

export default Vue.extend({
  props: {
    values: Object as Prop<FormValues>
  },
  methods: {
    correction() {
      this.$emit('correction', false)
    },
    submit() {
      const form = new FormData(this.$refs.form as HTMLFormElement)
      fetch('mailcon.php', { method: 'POST', body: form }).then(() => this.$router.push('/thanks'))
    }
  }
})
